import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { branch } from 'baobab-react/higher-order';
import { Redirect } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import NewContract from '../NewContract';
import NewContractMassive from '../NewContractMassive';
import Contracts from '../Contracts';

import SessionActions from '../../actions/Session';
import AlertModal from '../../components/Modals/AlertModal';
import CredentialsModal from '../../components/Modals/CredentialsModal';
import { NotificationManager } from 'react-notifications';
import { signersOrAdminsLoginUtils } from '../../utils/signersLoginUtils';
import Loader from '../../components/Loader';
import GenericConfirmModal from '../../components/Modals/GenericConfirmModal';
import ProfileActions from '../../actions/Profile';
import MySignerOrMyAdmins from '../Profile/MySignerOrMyAdmins';

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      admin: {
        legalRfc: '',
        legalName: '',
        email: '',
        canCreateContract: false,
        canSee: false,
        canCreateSigner: false,
        canCreateAdmin: false,
        canSign: false,
        showLogoutModal: true,
        loading: false,
      },
      modalInfoAlert: true,
    };
    this.idleTimer = null;
    this.onAction = this.onAction.bind(this);
    this.onActive = this.onActive.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.handleLogoutModal = this.handleLogoutModal.bind(this);
  }

  componentDidMount() {
    const { session, match } = this.props;
    const { user } = session;
    const { permissions } = user;
    const alertInfo = localStorage.getItem('alert_info');
    if (alertInfo) {
      this.setState({ modalInfoAlert: false });
    }
    const admin = permissions.find(
      (found) => found.legalRfc === match.params.legalRfc,
    );
    ProfileActions.signers(admin.rootUser);
    ProfileActions.admins(admin.rootUser);
    this.setState({ admin });
  }

  componentDidUpdate(prevProps, prevState) {
    const { session, match } = this.props;
    const { user } = session;
    const { permissions } = user;
    const admin = permissions.find(
      (found) => found.legalRfc === match.params.legalRfc,
    );
    if (admin !== prevState.admin) {
      this.setState({ admin });
    }
  }

  onAction(e) {
    //
  }

  onActive(e) {
    //
  }

  onIdle(e) {
    const { showLogoutModal } = this.state;
    this.setState({ showLogoutModal: !showLogoutModal });
  }

  // eslint-disable-next-line class-methods-use-this
  handleLogoutModal() {
    SessionActions.logout();
  }

  handleSubmit = async (credentials) => {
    const response = await signersOrAdminsLoginUtils(credentials, this.props);
    const { error, message } = response;
    if (error) {
      this.setState({ loading: false });
      // TODO: translate response
      return NotificationManager.error(message, 'Advertencia', 5000);
    }
  };

  onClickCloseModal = () => {
    localStorage.setItem('alert_info', true);
    this.setState({ modalInfoAlert: false });
  };

  render() {
    const { admin, showLogoutModal, loading, modalInfoAlert } = this.state;
    const {
      history,
      match,
      session,
      location,
      myAdmins,
      mySigners,
      lang,
      translations,
    } = this.props;
    const { texts, buttons } = translations[lang].Admin;
    if (!session) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: {
              from: location.pathname,
            },
          }}
        />
      );
    }
    return (
      <div className="admin_signer_container">
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1000 * 60 * 1200}
          stopOnIdle
        />
        <h1>{texts.h1(admin.legalName)}</h1>
        {session.user.typeUser && admin.protectedUser ? (
          <>
            {loading ? (
              <div className="center_loading">
                <Loader />
                <p>{texts.p1}</p>
              </div>
            ) : (
              <div className="page padded">
                <CredentialsModal handleSubmit={this.handleSubmit} />
              </div>
            )}
          </>
        ) : (
          <div className="page padded">
            <Tabs defaultIndex={0}>
              <TabList>
                {admin.canSee ? <Tab>{texts.tab1}</Tab> : false}
                {admin.canCreateContract ? <Tab>{texts.tab2}</Tab> : false}
                <Tab>{texts.tab3}</Tab>
                <Tab>{texts.tab4}</Tab>
              </TabList>

              {/* Contracts */}
              {admin.canSee ? (
                <TabPanel>
                  <Contracts signer={admin} history={history} match={match} />
                </TabPanel>
              ) : (
                false
              )}

              {/* NEW CONTRACT */}
              {admin.canCreateContract ? (
                <TabPanel>
                  <NewContract admin={admin} history={history} />
                </TabPanel>
              ) : (
                false
              )}

              {/* SIGNERS */}
              <TabPanel>
                {admin.canCreateSigner ? (
                  <MySignerOrMyAdmins
                    mySigners={mySigners}
                    user={session.user}
                    history={history}
                    location={location}
                    signer={admin}
                    type="signer"
                  />
                ) : (
                  false
                )}
                {admin.canCreateAdmin ? (
                  <MySignerOrMyAdmins
                    mySigners={myAdmins}
                    user={session.user}
                    history={history}
                    location={location}
                    signer={admin}
                    type="admin"
                  />
                ) : null}
              </TabPanel>
              <TabPanel>
                <NewContractMassive signerOrAdmin={admin} />
              </TabPanel>
            </Tabs>
          </div>
        )}
        {session.user.typeUser && admin.protectedUser && modalInfoAlert ? (
          <GenericConfirmModal
            title={texts.genericModalTitle1}
            message={texts.genericModalBody1(admin.legalName)}
            okButton={buttons.genericModalConfirmButton1}
            cancelButton={buttons.genericModalCancelButton1}
            cancelAction={() => this.onClickCloseModal()}
            acceptAction={() => this.onClickCloseModal()}
            type={'alert'}
          />
        ) : null}
        {showLogoutModal ? (
          <AlertModal
            message={texts.alertModalBody1}
            header={texts.alertModalTitle1}
            okButton={() => this.handleLogoutModal()}
          />
        ) : null}
      </div>
    );
  }
}

export default branch(
  {
    session: ['session'],
    mySigners: ['mySigners'],
    myAdmins: ['myAdmins'],
    translations: ['translations'],
    lang: ['lang'],
  },
  Admin,
);
